import React, { useState, useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopHeader from "./TopHeader";
import Breadcrumbs from "./Breadcrumbs";
import GlobalCommandPalette from "./GlobalCommandPalette";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function Layout() {
  const { user, loading } = useAuth();
  // AP-056 · Mobile sidebar drawer state.
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();
  useEffect(() => { setNavOpen(false); }, [location.pathname]);

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <Loader2 className="h-6 w-6 text-primary animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  return (
    // AP-022 · Fixed-sidebar layout.
    //   Sidebar is `fixed` at ≥lg (own scrollbar). Content column is offset by
    //   lg:pl-64 and gets its OWN scroll container (h-screen overflow-y-auto)
    //   so only the content scrolls while sidebar + topbar stay put.
    <div className="min-h-screen bg-muted/30">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <div
        data-testid="app-content-column"
        className="lg:pl-64 h-screen overflow-y-auto overflow-x-hidden flex flex-col jms-scroll"
      >
        <TopHeader onMenuClick={() => setNavOpen(true)} />
        <main className="flex-1 min-w-0">
          <div className="max-w-[1440px] mx-auto px-5 sm:px-8 md:px-10 lg:px-12 py-8 md:py-10 fade-up">
            <Breadcrumbs />
            <Outlet />
          </div>
        </main>
      </div>
      <GlobalCommandPalette />
    </div>
  );
}
